import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ffab66e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "staffing-form"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "form-inline" }
const _hoisted_5 = {
  class: "form-group ml-4",
  style: {"text-align":"left"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gridLevel" }, "Grid Level", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pcsRangeLevel" }, "PCS Range", -1))
const _hoisted_10 = {
  class: "font-weight-bold",
  style: {"padding-left":"5px !important"}
}
const _hoisted_11 = {
  id: "staffing-content-loading",
  class: "text-center mt-3"
}
const _hoisted_12 = { class: "fa-2x" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_14 = {
  key: 1,
  id: "staffing-content"
}
const _hoisted_15 = { id: "grdStaffing" }
const _hoisted_16 = {
  key: 2,
  id: "staffing-message",
  class: "text-center mt-3"
}
const _hoisted_17 = { id: "staffing-message-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "care-assignment-container-staffingmatrix" }, null, -1))
const _hoisted_19 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.pcsStaffingViewModel.pcsEnabled && _ctx.isShowStaffingContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("select", {
                    class: "neu-select filterSelect",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPCSRange) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pcsRangesOnChange && _ctx.pcsRangesOnChange(...args))),
                    style: {"width":"300px"},
                    "data-role": "dropdownlist",
                    "data-option-label": "Select a PCS Range"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pcsStaffingViewModel.pcsRanges, (pcs) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: pcs.fsDeptPatientClassificationRangeId,
                        key: pcs.fsDeptPatientClassificationRangeId
                      }, _toDisplayString(pcs.name), 9, _hoisted_7))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedPCSRange]
                  ]),
                  _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                    default: _withCtx(() => [
                      _createTextVNode("arrow_drop_down")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.pcsStaffingViewModel.pcsRangeLevel), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_13
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowStaffingContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.staffingData != null && _ctx.staffingData.length > 0)
              ? (_openBlock(), _createBlock(_component_neu_card, {
                  key: 0,
                  color: "plain-0",
                  class: "p-0 m-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_table_row, {
                          columns: _ctx.columnHeaders,
                          header: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                              return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                key: column,
                                slot: column,
                                icon: _ctx.columnIcons[column],
                                title: column,
                                style: {"padding-top":"25px !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(column), 1)
                                ]),
                                _: 2
                              }, 1032, ["slot", "icon", "title"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["columns"]),
                        _createVNode(_component_neu_table_body, { align: "left" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffingData, (staffDt) => {
                              return (_openBlock(), _createBlock(_component_neu_table_row, {
                                columns: _ctx.columnHeaders,
                                slot: _ctx.column,
                                key: staffDt,
                                class: _normalizeClass([staffDt['Highlight'] ? 'staffing-grid-highlight': ''])
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(staffDt), (dataItem) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: dataItem }, [
                                      (dataItem != 'Highlight')
                                        ? (_openBlock(), _createBlock(_component_neu_label, {
                                            key: 0,
                                            slot: dataItem
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(staffDt[dataItem]), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["slot"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["columns", "slot", "class"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowStaffingMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.staffingMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_18,
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}